import type React from 'react'

type RefType<T> =
  | React.RefCallback<T>
  | React.MutableRefObject<T>
  | React.ForwardedRef<T>

export function setRef<T> (ref: RefType<T>, value: T | null) {
  if (typeof ref === 'function') {
    ref(value)
  } else if (ref !== null && ref !== undefined) {
    ref.current = value
  }
}

export function mergeRefs<T> (...refs: React.Ref<T>[]): React.RefCallback<T> {
  return (value: T) => {
    refs.forEach(ref => {
      setRef(ref, value)
    })
  }
}
